import React from 'react';
import { Button, Flex, Typography, theme } from 'antd';
import { ArrowRightOutlined, CloseOutlined } from '@ant-design/icons';

const HEADING = 'See your first rendered page';
// Deliberately does not promise a before/after comparison. The proof is only
// fetched when this is clicked — that request queues a billable render — so the
// modal may open on a page still rendering, a non-200 status, or a proof with
// nothing worth comparing.
const BODY = 'See what crawlers now receive from your homepage.';

type RenderProofEntryPointBannerProps = {
  onView: () => void;
  onDismiss: () => void;
};

function RenderProofEntryPointBanner({
  onView,
  onDismiss,
}: RenderProofEntryPointBannerProps) {
  const { token } = theme.useToken();

  return (
    <Flex
      align="center"
      justify="space-between"
      gap={token.sizeXL}
      style={{
        background: `linear-gradient(78deg, ${token.colorBgContainer} 0%, ${token.colorPrimaryBg} 100%)`,
        border: `${token.lineWidth}px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG,
        padding: token.sizeXL,
      }}
    >
      <Flex vertical gap={token.margin}>
        <Flex vertical gap={token.marginXXS}>
          <Typography.Text strong style={{ fontSize: token.fontSizeLG }}>
            {HEADING}
          </Typography.Text>
          <Typography.Text type="secondary" style={{ fontSize: token.fontSize }}>
            {BODY}
          </Typography.Text>
        </Flex>

        <Flex wrap align="center" gap={token.margin}>
          <Button type="primary" icon={<ArrowRightOutlined />} onClick={onView}>
            View render proof
          </Button>
          <Button
            type="link"
            icon={<CloseOutlined />}
            onClick={onDismiss}
            style={{ color: token.colorPrimary }}
          >
            Dismiss
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default RenderProofEntryPointBanner;
